// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".btn-right[data-v-6327b4fc]{right:20px}.btn-left[data-v-6327b4fc],.btn-right[data-v-6327b4fc]{bottom:10px;position:fixed}.btn-left[data-v-6327b4fc]{left:20px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
